import { apiConfig } from '../config/api';

export interface AppointmentSlot {
  id: string;
  startTime: string;
  endTime: string;
  isBooked: boolean;
  createdAt: string;
}

export interface Appointment {
  id: string;
  slotId: string;
  brandName: string;
  hostName: string;
  hostEmail: string;
  participantEmails: string[];
  meetLink: string;
  status: string;
  createdAt: string;
  slot?: AppointmentSlot;
}

const BASE_URL = apiConfig.appointmentsApi;
// Fallback if the config doesn't have appointmentsApi
const API_URL = BASE_URL ? `${BASE_URL}/api/v1/appointments` : 'https://api.fashcortex.com/api/v1/appointments';

export class AppointmentAdminService {
  /**
   * Admin: Tüm randevuları getir
   */
  static async getAllAppointments(token: string): Promise<Appointment[]> {
    const response = await fetch(`${API_URL}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Randevular getirilemedi');
    }

    const data = await response.json();
    return data.data.appointments;
  }

  /**
   * Admin: Tüm slotları getir
   */
  static async getAllSlots(token: string): Promise<AppointmentSlot[]> {
    console.log('[AppointmentAdminService] getAllSlots çağrılıyor:', `${API_URL}/slots`);
    const response = await fetch(`${API_URL}/slots`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    console.log('[AppointmentAdminService] getAllSlots response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('[AppointmentAdminService] getAllSlots hata:', errorText);
      throw new Error(`Slotlar getirilemedi: ${response.status}`);
    }

    const data = await response.json();
    console.log('[AppointmentAdminService] getAllSlots data:', data);
    return data.data.slots;
  }

  /**
   * Admin: Yeni slot oluştur
   */
  static async createSlot(token: string, startTime: string): Promise<AppointmentSlot> {
    const response = await fetch(`${API_URL}/slots`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ startTime })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Slot oluşturulamadı');
    }

    const data = await response.json();
    return data.data.slot;
  }

  /**
   * Admin: Slot sil
   */
  static async deleteSlot(token: string, slotId: string): Promise<void> {
    const response = await fetch(`${API_URL}/slots/${slotId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Slot silinemedi');
    }
  }

  /**
   * Admin: Meet link güncelle
   */
  static async updateMeetLink(token: string, appointmentId: string, meetLink: string): Promise<Appointment> {
    const response = await fetch(`${API_URL}/${appointmentId}/meet-link`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ meetLink })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Meet linki güncellenemedi');
    }

    const data = await response.json();
    return data.data.appointment;
  }

  /**
   * Admin: Randevu sil
   */
  static async deleteAppointment(token: string, appointmentId: string): Promise<void> {
    const response = await fetch(`${API_URL}/${appointmentId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Randevu silinemedi');
    }
  }

  /**
   * Admin: Toplu slot oluştur
   */
  static async createBulkSlots(token: string, startTimes: string[]): Promise<{ createdSlots: AppointmentSlot[], createdCount: number, errors: string[] }> {
    const response = await fetch(`${API_URL}/slots/bulk`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ startTimes })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Slotlar oluşturulamadı');
    }

    const data = await response.json();
    return data.data;
  }
}
